import * as mutations from "./types";
export default {
  get_work_sources(context, work_sources) {
    context.commit(mutations.GET_WORK_SOURCES, work_sources);
  },
  get_salary_sources(context, salary_sources) {
    context.commit(mutations.GET_SALARY_SOURCES, salary_sources);
  },
  setNavChatAction(context, payload) {
    context.commit(mutations.setNavbarChatNotifs, payload);
  },
  emptyNavAction(context) {
    context.commit("emptyNavData");
  },

  showLoader(context) {
    context.commit('SET_LOADING', true);
  },
  hideLoader(context) {
    context.commit('SET_LOADING', false);
  },

  // Theme actions - optimized
  async initializeTheme(context) {
    // Check localStorage first
    const saved = localStorage.getItem('theme');
    if (saved === 'dark') {
      context.commit(mutations.SET_THEME, true);
    } else if (saved === 'light') {
      context.commit(mutations.SET_THEME, false);
    } else {
      // Default to dark mode and store in localStorage
      context.commit(mutations.SET_THEME, true);
      localStorage.setItem('theme', 'dark');
    }
  },

  setTheme(context, isDark) {
    context.commit(mutations.SET_THEME, isDark);
  },

  async toggleTheme(context) {
    // Show full page theme switch loading
    const isDark = !context.state.isDark;
    context.dispatch('preloader/showFullPageThemeSwitch', isDark);
    
    try {
      // Use requestAnimationFrame for smooth transition
      await new Promise(resolve => {
        requestAnimationFrame(() => {
          context.commit(mutations.TOGGLE_THEME);
          resolve();
        });
      });
      
      // Wait for CSS transitions to complete
      await new Promise(resolve => setTimeout(resolve, 800));
    } finally {
      // Hide loading state
      context.dispatch('preloader/hidePreloader');
    }
  },
};
